import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getLeaderboardLoadMoreStyles = (theme: Theme) =>
  StyleSheet.create({
    wrap: {
      paddingHorizontal: 16,
      paddingVertical: 12,
      alignItems: 'center',
      justifyContent: 'center',
    },
    button: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      paddingVertical: 10,
      paddingHorizontal: 22,
      borderRadius: 999,
      borderWidth: 1.5,
      borderColor: theme.gray[200],
      backgroundColor: theme.background.card,
    },
    buttonPressed: {
      opacity: 0.7,
    },
    buttonHover: {
      borderColor: theme.primary + '80',
    },
    label: {
      fontSize: 13,
      fontWeight: '700',
      color: theme.primary,
    },
    spinnerRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      paddingVertical: 4,
    },
    loadingLabel: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[500],
      ...Platform.select({ web: { userSelect: 'none' as never } }),
    },
  });
